import { BaseMapper } from '@/core/mapper';
import { Country } from '@/core/common';
import { Vendor } from '@/core/vendor';

import AssessmentField from '@/core/assessment/data/assessment-field.mapper';

const schema = {
  clients: {
    fromResponse: entity => _.get(entity, 'relationships.clients.data', [])
      .map(client => new Vendor(client)),
    omitFromRequest: true,
  },
  country: {
    fromResponse: (entity) => {
      const country = _.get(entity, 'relationships.country');
      return country && new Country(country);
    },
    omitFromRequest: true,
  },
  fields: {
    fromResponse: entity => _.get(entity, 'relationships.fields.data', [])
      .map(field => new AssessmentField(field)),
    omitFromRequest: true,
  },
  service_categories: {
    parseFrom: 'relationships.service_categories.data',
    omitFromRequest: true,
  },
  title: {
    parseFrom: 'attributes.title',
    omitFromRequest: true,
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
};

class AssessmentSection extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }

  flattened(fields = this.fields) {
    return _.flattenDeep(fields.map(field => field.flattened()));
  }
}

AssessmentSection.schema = schema;

export default AssessmentSection;
